import type {EditorAdapter,EditorSelection,SaveReceipt} from './EditorPort'
import {createEditorSession} from './EditorSession'

export interface SuiteReply {ok:boolean;error?:string;bytes?:ArrayBuffer;revision?:number;model_epoch?:number;selection?:EditorSelection;deferred?:boolean}
export function createSuiteEditor(options:{app:'documents'|'sheets';request:(type:string,values?:Record<string,unknown>)=>Promise<SuiteReply>;loaded:()=>boolean;blocked:()=>boolean;save:()=>Promise<SaveReceipt>}){
 let closed=false,target:EditorSelection|null=null
 const unsupported=async()=>{throw Error('This editing operation is not enabled.')}
 const adapter:EditorAdapter={
  capabilities:()=>({protocol:1,engine:'artcraft-'+options.app,selection:true,inline:false,commands:[],nativeCharts:false,imagePaste:false,guardedSelection:true}),
  loaded:()=>!closed&&options.loaded(),blocked:options.blocked,subscribe:()=>()=>{},onInline:()=>()=>{},
  async captureSelection(){const reply=await options.request('folio:selection');if(!reply.selection?.id||!reply.selection.stamp)throw Error('The editor did not return a selection.');return reply.selection},
  async copyText(){return (await adapter.captureSelection()).text},
  async focus(selection){
   target=null;await options.request('folio:selection-check',{selection_id:selection.id,stamp:selection.stamp});target=selection
  },
  async paste(data){
   const selection=target;target=null
   if(closed||!selection||typeof data!=='string')throw Error('Capture a fresh text target before inserting.')
   // One conditional mutation in the engine frame, rather than a focus/paste
   // pair that could overwrite a selection moved between asynchronous replies.
   await options.request('folio:insert-reviewed',{selection_id:selection.id,stamp:selection.stamp,text:data})
  },
  save:options.save,command:unsupported,insertInline:unsupported,
  configureInline(){},inlineResult(){},openInline(){},closeInline(){},hideSidebar(){},
  dispose(){closed=true;target=null},
 }
 return createEditorSession(adapter)
}
